import { render, staticRenderFns } from "./locationCard.vue?vue&type=template&id=dc88bb98&scoped=true&"
import script from "./locationCard.vue?vue&type=script&lang=js&"
export * from "./locationCard.vue?vue&type=script&lang=js&"
import style0 from "./locationCard.vue?vue&type=style&index=0&id=dc88bb98&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc88bb98",
  null
  
)

export default component.exports